// JS
import Collapse from 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
import './post-modal.js';
import '../scss/app.scss';

document.addEventListener('DOMContentLoaded', function () {
  const toggler = document.querySelector('.navbar-toggler');
  const overlay = document.querySelector('.mobile-overlay');
  const header = document.querySelector('.site-header');
  const menu = document.getElementById('primaryMenu');

  if (!menu) return; // nic nie rób, jeśli nie ma menu

  // Zamykaj menu po kliknięciu w link
  menu.querySelectorAll('a.nav-link').forEach(link => {
    link.addEventListener('click', () => {
      if (menu.classList.contains('show')) {
        const bsCollapse = Collapse.getOrCreateInstance(menu);
        bsCollapse.hide();
      }
    });
  });

  if (toggler && overlay) {
    // Pokaz/ukryj overlay + klasę na headerze
    menu.addEventListener('show.bs.collapse', () => {
      header?.classList.add('menu-open');
      overlay.classList.add('menu-open');
    });

    menu.addEventListener('hide.bs.collapse', () => {
      header?.classList.remove('menu-open');
      overlay.classList.remove('menu-open');
    });

    // Klik w overlay zamyka menu
    overlay.addEventListener('click', () => {
      const bsCollapse = Collapse.getOrCreateInstance(menu);
      bsCollapse.hide();
    });
  }


  const btn = document.querySelector(".booksy-floating-btn");

  window.addEventListener("scroll", function () {
    if (window.scrollY > 400) {
      btn.classList.add('visible');
    } else {
      btn.classList.remove('visible');
    }
  });



});




jQuery(function ($) {
  $('.trainers-slick').each(function () {
    const $slider = $(this);
    const visible = parseInt($slider.data('visible'), 10) || 4;

    $slider.slick({
      slidesToShow: visible,
      slidesToScroll: visible,      // przewijaj „ekranami”
      infinite: false,
      arrows: true,
      dots: false,
      swipe: true,
      touchThreshold: 10,
      speed: 350,
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 900, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 560, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      ]
    });
  });


  $(document).on('click', '.trainer-name', function (e) {
    e.preventDefault();
    const $card = $(this).closest('.trainer-card');
    const title = $(this).text();
    const desc = $card.find('.trainer-desc').html();

    // Wstaw dane do modala
    const $modal = $('#trainerModal');
    $modal.find('.modal-title').text(title);
    $modal.find('.modal-body').html(desc);

    // Otwórz modal przez API Bootstrap 5
    const modal = new Modal($modal[0]);
    modal.show();
  });

 
});


